import * as swcHelpers from '@swc/helpers';
import { renderToString } from 'react-dom/server';
import { getServerState } from 'react-instantsearch';

function getAlgoliaServerState(component) {
    return _getAlgoliaServerState.apply(this, arguments);
}
function _getAlgoliaServerState() {
    _getAlgoliaServerState = swcHelpers.asyncToGenerator(function*(component) {
        try {
            return yield getServerState(component, {
                renderToString
            });
        } catch (error) {
            console.error('An error occurred while fetching algolia server state:', error);
        }
    });
    return _getAlgoliaServerState.apply(this, arguments);
}

export { getAlgoliaServerState };
//# sourceMappingURL=get-algolia-server-state.js.map
